export default "__VITE_ASSET__bc7ef56d__"